import {
  DashboardMenu,
  DashboardMenuItem,
} from "../molecules/dashboard.menu/dashboard.menu";
import { LogoJourgui } from "../ui";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  LayoutDashboardIcon,
  Calendar,
  MessageSquareMore,
  Users,
  Settings,
  ChartColumn,
  LogOut,
  Presentation,
} from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "../../composables/auth/use.auth";
import { UserTypes } from "../../composables/users";

export default function DashboardSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [pathname, setPathname] = useState(location.pathname);
  const { logout, currentUserAuthorized } = useAuth();

  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname]);

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();

    await logout();
  };

  const activeRouteSubRoutes = (pathname: string): string => {
    const reg = new RegExp(`^${pathname}(?:\/.*)?$`);
    return reg.test(location.pathname) ? "active" : "";
  };

  return (
    <div className="dashboard-sidebar">
      <div style={{ padding: "1rem 2rem" }}>
        <LogoJourgui width={100} />
      </div>
      <DashboardMenu>
        {currentUserAuthorized([
          UserTypes.ADMINISTRATEUR,
          UserTypes.TECHNIQUE,
        ]) && (
          <DashboardMenuItem
            icon={<Home width={20} />}
            path={"/dashboard"}
            className={pathname === "/dashboard" ? "active" : ""}
            title="Accueil"
          />
        )}
        {currentUserAuthorized([
          UserTypes.ADMINISTRATEUR,
          UserTypes.TECHNIQUE,
          UserTypes.PARTICULIER,
          UserTypes.ENTREPRISE,
        ]) && (
          <DashboardMenuItem
            className={activeRouteSubRoutes("/dashboard/campagnes")}
            icon={<Calendar width={20} />}
            path={"/dashboard/campagnes"}
            title="Campagnes"
          />
        )}
        {currentUserAuthorized([
          UserTypes.ADMINISTRATEUR,
          UserTypes.TECHNIQUE,
        ]) && (
          <DashboardMenuItem
            icon={<LayoutDashboardIcon width={20} />}
            className={activeRouteSubRoutes("/dashboard/commandes")}
            path={"/dashboard/commandes"}
            title="Commandes"
          />
        )}
        {currentUserAuthorized([
          UserTypes.TERRAIN,
          UserTypes.ADMINISTRATEUR,
          UserTypes.TECHNIQUE,
        ]) && (
          <DashboardMenuItem
            icon={<Users width={20} />}
            className={activeRouteSubRoutes("/dashboard/enrolements")}
            path={"/dashboard/enrolements"}
            title="Enrolements"
          />
        )}
        {currentUserAuthorized([UserTypes.ADMINISTRATEUR]) && (
          <DashboardMenuItem
            icon={<LayoutDashboardIcon width={20} />}
            path={"/dashboard"}
            title="Finance"
          />
        )}
        {currentUserAuthorized([UserTypes.FOURNISSEUR]) && (
          <DashboardMenuItem
            icon={<ChartColumn width={20} />}
            className={activeRouteSubRoutes("/dashboard/boucles")}
            path={"/dashboard/boucles"}
            title="Gestion des boucles"
          />
        )}
        {currentUserAuthorized([
          UserTypes.ADMINISTRATEUR,
          UserTypes.TECHNIQUE,
        ]) && (
          <DashboardMenuItem
            icon={<Presentation width={20} />}
            path={"/dashboard"}
            title="Tableau de bord"
          />
        )}
        <DashboardMenuItem
          icon={<MessageSquareMore width={20} />}
          path={"/dashboard"}
          title="Messagerie"
        />
        {currentUserAuthorized([
          UserTypes.ADMINISTRATEUR,
          UserTypes.TECHNIQUE,
          UserTypes.TERRAIN,
        ]) && (
          <DashboardMenuItem
            icon={<Users width={20} />}
            className={activeRouteSubRoutes("/dashboard/users")}
            path={"/dashboard/users"}
            title="Gestion des utilisateurs"
          />
        )}

        <DashboardMenuItem
          icon={<Settings width={20} />}
          className={activeRouteSubRoutes("/dashboard/profil")}
          path={"/dashboard/profil"}
          title="Mon profil"
        />
      </DashboardMenu>

      <div className="py-5 pt-10">
        <DashboardMenu>
          <DashboardMenuItem
            icon={<LogOut width={20} />}
            onClick={handleLogout}
            path={"/logout"}
            title="Déconnexion"
          />
        </DashboardMenu>
      </div>
    </div>
  );
}
